import React, { useState } from "react";
import About1 from "../assets/img/about1.png";
import About2 from "../assets/img/about2.png";
import About3 from "../assets/img/365cert.jpg";
import About4 from "../assets/img/about4.png";
import About5 from "../assets/img/about5.png";
import About6 from "../assets/img/about6.png";
// import Partner1 from "../assets/img/partner1.png";
// import Partner2 from "../assets/img/partner2.png";
import AboutBg from "../assets/img/aboutBg.png";
import ScrollingPartners from "../components/ScrollingPartners";

const About = () => {
  const [openIndex, setOpenIndex] = useState(-1);

  const statsData = [
    {
      title: "99.9%",
      subtitle: "Success Rate",
      details: [
        "We proudly boast an impressive 99.9% success rate in placing students in top international schools and programs.",
        "Visa Success Guaranteed: Our expertise ensures an exceptional 99.9% visa success rate, giving you peace of mind.",
        "With our impressive success rate and expert guidance, you can trust us to help you achieve your international education dreams.",
      ],
    },
    {
      title: "2k+",
      subtitle: "Happy Students",
      details: [
        "Join our community of 2,000+ successful students worldwide who have benefited from our expert guidance and support in achieving their study abroad goals.",
      ],
    },
    {
      title: "13+ yrs",
      subtitle: "Of Experience",
      details: [
        "Expert guidance you can trust! Our team boasts 13+ years of industry experience, ensuring you receive top-notch advice for your international education journey.",
      ],
    },
    {
      title: "500+",
      subtitle: "Schools Processed",
      details: [
        "We have Partnerships with over 500 schools and Universities around the world, ensuring endless opportunities for our students and access to top programmes.",
      ],
    },
  ];

  const handleBoxClick = (index) => {
    // Toggle the clicked box; close if clicked again
    setOpenIndex(openIndex === index ? -1 : index);
  };

  return (
    <div className="container mx-auto px-4">
      <div className="block bg-white h-[130px]"></div>
      <div className="relative w-full h-[200px] md:h-[280px] overflow-hidden group rounded-3xl">
        <img
          src={AboutBg}
          alt="Background"
          className="w-full h-full object-cover rounded-3xl transition-transform duration-500 group-hover:scale-110"
        />

        <div className="absolute inset-0 flex items-center justify-center">
          <h1 className="text-white text-4xl md:text-6xl font-bold text-center">
            About Us
          </h1>
        </div>
      </div>

      <section className="py-20">
        {/* Section Title */}
        <div className="text-center mx-auto mb-16">
          <h2 className=" text-3xl md:text-4xl font-bold text-primary ">
            A <span className="text-secondary">One-Stop Shop</span> For All Your
            Study Abroad <br /> Needs
          </h2>
        </div>

        {/* Content Grid */}
        <div className="container mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Image 1 */}
          <div className=" justify-center rounded-2xl overflow-hidden">
            <img
              src={About2}
              alt="Students Studying"
              className="hidden md:block rounded-lg object-cover transition-transform duration-500 hover:scale-110 md:w-auto"
            />
            {/* Founder's Quote */}
            <div className="bg-primary mt-6 text-white p-6 rounded-3xl shadow-lg">
              <h4 className="text-lg font-semibold mb-4">Founder's Quote</h4>
              <p className="text-sm leading-relaxed text-justify">
                "Having navigated the complexities of international education
                myself, I knew there had to be a better way. That's why we
                created 365 - to provide the support and guidance that I wished
                I had. We are committed to supporting you every step of the way,
                from start to finish."
              </p>
            </div>
          </div>

          {/* Center Column */}
          <div className="flex flex-col items-center justify-between space-y-6 rounded-2xl overflow-hidden ">
            {/* Main Image */}
            <img
              src={About1}
              alt="Main Student"
              className="rounded-lg object-cover transition-transform duration-500 hover:scale-110 w-full md:w-auto"
            />
          </div>

          {/* Image 2 */}
          <div className="flex flex-col space-y-6 rounded-2xl overflow-hidden">
            <img
              src={About3}
              alt="Group of Students"
              className="rounded-lg object-cover transition-transform duration-500 hover:scale-110 h-60 w-full"
            />
            <img
              src={About4}
              alt="University Building"
              className="hidden md:block rounded-lg object-cover transition-transform duration-500 hover:scale-110 w-48"
            />
          </div>
        </div>
      </section>

      <div className="mt-24 flex flex-col md:flex-row justify-between gap-16">
        <div className="md:w-1/2">
          <h3 className="text-center md:text-start font-bold text-primary text-3xl">
            Who We Are
          </h3>
          <p className="text-lg  opacity-80 my-8 text-justify">
            365 Global Consulting is a distinguished independent education
            consulting firm dedicated to providing exceptional, unbiased, and
            comprehensive career counseling and educational services. Our
            mission is to empower students to gain admission into their ideal
            schools, colleges, and universities—both internationally and
            locally.
            <br />
            <br />
            As a one-stop shop for all your study abroad needs, we prioritize
            your preferred career path, study destination, and living standards
            as an international student. We understand that each student’s
            journey is unique, and we are committed to guiding you through every
            step of the application process to ensure you reach your educational
            goals at the institution of your choice.
          </p>
          <a
            href="/contactus"
            className="uppercase text-white bg-secondary  py-3 px-8 rounded-full hover:bg-gray-cool duration-500"
          >
            contact us
          </a>
        </div>
        <div className="rounded-2xl overflow-hidden">
          <img
            src={About5}
            alt="Main Student"
            className="rounded-lg w-full h-full object-cover transition-transform duration-500 hover:scale-110"
          />
        </div>
      </div>
      <div className="mt-24 flex flex-col md:flex-row justify-between items-center gap-16">
        <div className="rounded-2xl overflow-hidden">
          <img
            src={About6}
            alt="Main Student"
            className="rounded-lg w-full h-full object-cover transition-transform duration-500 hover:scale-110"
          />
        </div>
        <div className="md:w-1/2">
          <h3 className="text-center md:text-start font-bold text-primary text-3xl">
            Our Vision
          </h3>
          <p className="text-lg  opacity-80 my-8 text-justify">
            At 365 Global Consulting, we believe that every student deserves the
            opportunity to pursue their dreams. Let us be your trusted partner
            in navigating the complexities of studying abroad, providing the
            support and expertise you need to make informed decisions for a
            successful future.
          </p>
          <a
            href="/contactus"
            className="uppercase text-white bg-secondary  py-3 px-8 rounded-full hover:bg-gray-cool duration-500"
          >
            contact us
          </a>
        </div>
      </div>
      <div className="mt-24">
        <div className="text-center mb-16">
          <h2 className=" text-3xl md:text-4xl font-bold text-primary ">
            Our Bragging Rights
          </h2>
        </div>
        {/* <div className="flex flex-wrap justify-between">
          <div className="border border-gray-neutral bg-alice-blue w-full mb-4 md:max-w-[270px] py-14 rounded-2xl flex flex-col items-center justify-center">
            <div>
              <h2 className="text-primary font-bold text-5xl">99.9%</h2>
              <div className="w-8 h-2 bg-Viridian"></div>
            </div>
            <p className="text-2xl mt-3">Success Rate</p>
          </div>
          <div className="border border-gray-neutral bg-alice-blue w-full mb-4 md:max-w-[270px] py-14 rounded-2xl flex flex-col items-center justify-center">
            <div>
              <h2 className="text-primary font-bold text-5xl">2k+</h2>
              <div className="w-8 h-2 bg-Viridian"></div>
            </div>
            <p className="text-2xl mt-3">Happy Students</p>
          </div>
          <div className="border border-gray-neutral bg-alice-blue w-full mb-4 md:max-w-[270px] py-14 rounded-2xl flex flex-col items-center justify-center">
            <div>
              <h2 className="text-primary font-bold text-5xl">13+ yrs</h2>
              <div className="w-8 h-2 bg-Viridian"></div>
            </div>
            <p className="text-2xl mt-3">Of Experience</p>
          </div>
          <div className="border border-gray-neutral bg-alice-blue w-full mb-4 md:max-w-[270px] py-14 rounded-2xl flex flex-col items-center justify-center">
            <div>
              <h2 className="text-primary font-bold text-5xl">500+</h2>
              <div className="w-8 h-2 bg-Viridian"></div>
            </div>
            <p className="text-2xl mt-3">Schools Processed</p>
          </div>
        </div> */}

        <div className="flex flex-wrap justify-between">
          {statsData.map((item, index) => (
            <div
              key={index}
              onClick={() => handleBoxClick(index)}
              className={`
              cursor-pointer border border-gray-neutral bg-alice-blue 
              w-full mb-4 md:max-w-[270px] py-14 
              flex flex-col items-center justify-center 
              transition-all duration-500 ease-in-out transform
              hover:shadow-lg
              ${
                openIndex === index
                  ? // Styles when the box is active
                    "rounded-[2rem] scale-105 shadow-xl"
                  : // Styles when the box is inactive
                    "rounded-2xl scale-100 shadow-none"
              }
            `}
            >
              <div>
                <h2 className="text-primary font-bold text-5xl">
                  {item.title}
                </h2>
                <div className="w-8 h-2 bg-Viridian"></div>
              </div>
              <p className="text-2xl mt-3">{item.subtitle}</p>

              {/* Reveal bullet points if this box is open */}
              <div
                className={`
                m-4 text-start md:text-sm text-gray-700
                transition-max-height duration-500 ease-in-out overflow-hidden 
                ${openIndex === index ? "max-h-96" : "max-h-0"}
              `}
              >
                <ul className="list-disc list-inside">
                  {item.details.map((detail, i) => (
                    <li key={i} className="mt-2">
                      {detail}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="mt-24 hidden">
        <div className="text-center mb-16">
          <h2 className="capitalize text-3xl md:text-4xl font-bold text-primary ">
            our <span className="text-secondary">expert</span> counselling{" "}
            <span className="text-secondary">team</span>
          </h2>
        </div>
        <div className="flex flex-wrap justify-between">
          <div className="bg-primary mb-4 w-full md:max-w-[270px] rounded-2xl flex flex-col items-center justify-center">
            <div>
              <img src={About1} alt="" />
            </div>
            <div className="text-white text-center py-3">
              <h5 className="text-xl">Victoria Adegoke</h5>
              <p className="text-base">CEO</p>
            </div>
          </div>
          <div className="bg-primary mb-4 w-full md:max-w-[270px] rounded-2xl flex flex-col items-center justify-center">
            <div>
              <img src={About1} alt="" />
            </div>
            <div className="text-white text-center py-3">
              <h5 className="text-xl">Victoria Adegoke</h5>
              <p className="text-base">CEO</p>
            </div>
          </div>
          <div className="bg-primary mb-4 w-full md:max-w-[270px] rounded-2xl flex flex-col items-center justify-center">
            <div>
              <img src={About1} alt="" />
            </div>
            <div className="text-white text-center py-3">
              <h5 className="text-xl">Victoria Adegoke</h5>
              <p className="text-base">CEO</p>
            </div>
          </div>
          <div className="bg-primary mb-4 w-full md:max-w-[270px] rounded-2xl flex flex-col items-center justify-center">
            <div>
              <img src={About1} alt="" />
            </div>
            <div className="text-white text-center py-3">
              <h5 className="text-xl">Victoria Adegoke</h5>
              <p className="text-base">CEO</p>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-24">
        <div className="text-center mb-10">
          <h2 className="capitalize text-3xl md:text-4xl font-bold text-primary ">
            our partnerships
          </h2>
          <p className="opacity-80 mt-4 text-base ">
            We have illustrious partnerships with renowned organizations such as
          </p>
        </div>
        {/* <div className="flex  justify-between">
          <div className=" w-full rounded-2xl flex flex-col items-center justify-center">
            <img src={Partner1} alt="" />
          </div>
          <div className=" w-full rounded-2xl flex flex-col items-center justify-center">
            <img src={Partner2} alt="" />
          </div>
          <div className=" w-full rounded-2xl flex flex-col items-center justify-center">
            <img src={Partner1} alt="" />
          </div>
          <div className=" w-full rounded-2xl flex flex-col items-center justify-center">
            <img src={Partner2} alt="" />
          </div>
        </div> */}
        <ScrollingPartners />
      </div>
    </div>
  );
};

export default About;
